export const splitTextIntoTitleAndBody = (text) => {
  // Split the text into an array of sentences
  let sentences = text.match(/[^\.!\?]+[\.!\?]+/g);

  // Initialize variables to store the title and body
  let title = "";
  let body = "";

  // If there are sentences
  if (sentences && sentences.length > 0) {
    // If there's only one sentence, consider it as the body
    if (sentences.length === 1) {
      body = sentences[0].trim();
    } else {
      // If there are multiple sentences, set the first sentence as the title
      title = sentences[0].trim();
      // Combine the remaining sentences as the body
      body = sentences.slice(1).join("").trim();
    }
  } else {
    // If no sentences found, consider the whole text as the body
    body = text.trim();
  }

  return { title: title, body: body };
};
